var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98659 14.6299L9 15.4914L8.01341 14.6299C4.48958 11.5529 2.7 8.83009 2.7 6.3C2.7 2.71927 5.49314 0 9 0C12.5069 0 15.3 2.71927 15.3 6.3C15.3 8.83009 13.5104 11.5529 9.98659 14.6299ZM3.317 11.5231C3.68653 12.029 4.09816 12.5436 4.55173 13.0671C2.87573 13.4446 1.8 13.9803 1.8 14.4C1.8 15.1263 5.02123 16.2 9 16.2C12.9788 16.2 16.2 15.1263 16.2 14.4C16.2 13.9803 15.1243 13.4446 13.4483 13.0671C13.9018 12.5436 14.3135 12.029 14.683 11.5231C16.7069 12.1372 18 13.1223 18 14.4C18 16.6561 13.9682 18 9 18C4.03176 18 0 16.6561 0 14.4C0 13.1223 1.29306 12.1372 3.317 11.5231ZM9 1.8C11.5234 1.8 13.5 3.72434 13.5 6.3C13.5 8.14227 12.0354 10.4093 9 13.1004C5.96459 10.4093 4.5 8.14227 4.5 6.3C4.5 3.72434 6.47662 1.8 9 1.8ZM9 3.6C10.4912 3.6 11.7 4.80883 11.7 6.3C11.7 7.79117 10.4912 9 9 9C7.50883 9 6.3 7.79117 6.3 6.3C6.3 4.80883 7.50883 3.6 9 3.6ZM8.1 6.3C8.1 5.80294 8.50294 5.4 9 5.4C9.49706 5.4 9.9 5.80294 9.9 6.3C9.9 6.79706 9.49706 7.2 9 7.2C8.50294 7.2 8.1 6.79706 8.1 6.3Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f0cba951a9191ea6aae4b65bc13a7c1f.svg";
export { ForwardRef as ReactComponent };